import React from 'react';
import { Link } from 'react-router-dom';
import SortableList from '../shared/SortableList';
import ListItem from '../shared/ListItem';
import Pagination from '../shared/Pagination';
import SearchInput from '../form/SearchInput';
import FilterBar from '../shared/FilterBar';
import ActiveFilters from '../shared/ActiveFilters';
import { debounce, parseFilters } from '../../helpers/util';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { maskMoney, maskDate } from '../../masks';
import withTracker from '../withTracker';
import { maskCapitalizeFirstLetter } from '../../masks';

class AdminDishes extends React.Component {
  state = {
    searchTerm: '',
    sortBy: [],
    dishes: [],
    pagination: {},
    availableFilters: {
      dietary_preference_tags: {
        label: 'Diet',
        type: 'checkbox',
        prop: 'tag',
        options: []
      },
      allergens: {
        label: 'Allergens',
        prefix: 'No ',
        type: 'checkbox',
        prop: 'tag',
        options: []
      },
      seasonality_tags: {
        label: 'Seasonality',
        type: 'checkbox',
        prop: 'tag',
        options: []
      },
      cuisine: {
        label: 'Cuisine',
        type: 'checkbox',
        prop: 'name',
        options: []
      },
      category: {
        label: 'Categories',
        type: 'checkbox',
        prop: 'name',
        options: []
      },
      complexity: {
        label: 'Complexity',
        type: 'checkbox',
        prop: 'label',
        options: [
          { id: "basic", label: "Basic"},
          { id: "simple", label: "Simple"},
          { id: "moderate", label: "Moderate"},
          { id: "intensive", label: "Intensive"}
        ]
      },
      format: {
        label: 'Format',
        type: 'checkbox',
        prop: 'label',
        options: [
          { id: "is_weekly", label: "Weekly"},
          { id: "is_special_occasion", label: "Special Occasion"},
          { id: "is_large_party", label: "Large Party"}
        ]
      }
    },
    activeFilters: [],
    isLoading: true
  };

  columns = [
    {
      label: 'Name',
      key: 'name',
      link: {
        to: '/admin/dish/[id]',
        advancedLabel: {
          combine: [
            { key: 'name' },
            { key: 'child_name', className: 'table__td--new-line p--em' }
          ]
        }
      },
      class: 'dishes__td--name'
    },
    {
      label: 'Price (sm.)',
      key: 'price_cents',
      mask: maskMoney,
      class: 'dishes__td--price table__td--right'
    },
    {
      label: 'Category',
      sortable: false,
      class: 'dishes__td--category',
      combine: [
        { key: 'category', dive: 'name' },
        { key: 'category_2', dive: 'name', className: 'table__td--new-line' },
        { key: 'category_3', dive: 'name', className: 'table__td--new-line' }
      ]
    },
    {
      label: 'Diet',
      key: 'dietary_preference_tags',
      dive: 'tag',
      sortable: false,
      class: 'dishes__td'
    },
    {
      label: 'Complexity',
      key: 'complexity',
      sortable: false,
      class: 'dishes__td',
      mask: (val) => maskCapitalizeFirstLetter(val).substring(0, 4) + '.'
    },
    {
      label: 'Format',
      combine: [
        { key: 'format', dive: 'is_weekly', mask: (val) => val ? 'Weekly' : ''},
        { key: 'format', dive: 'is_special_occasion', 
          mask: val => val ? 'Special Occasion' : '',
          className: 'table__td--new-line' },
        { key: 'format', dive: 'is_large_party',
          mask: val => val ? 'Large Party' : '',
          className: 'table__td--new-line' }
      ],
      sortable: false,
      class: 'dishes__td',
      mask: maskCapitalizeFirstLetter
    },
    {
      label: 'Allergens',
      key: 'allergens',
      dive: 'tag',
      sortable: false,
      class: 'dishes__td--allergens'
    },
    {
      label: 'Seasons',
      key: 'seasonalities',
      dive: 'tag',
      sortable: false,
      class: 'dishes__td'
    },
    {
      label: 'Cuisine',
      key: 'cuisines',
      dive: 'name',
      sortable: false,
      class: 'dishes__td'
    },
    {
      label: 'Date Added',
      key: 'created_at',
      mask: maskDate,
      class: 'dishes__td--date'
    },
    {
      link: { to: '/admin/dish/[id]', label: 'Edit' },
      sortable: false,
      class: 'dishes__td--edit'
    }
  ];

  render() {
    const {
      activeFilters,
      availableFilters,
      searchTerm,
      pagination,
      sortBy,
      dishes,
      isLoading
    } = this.state;
    const {
      columns,
      handleChange,
      handleSort,
      handlePaginate,
      toggleFilter,
      swapFilter
    } = this;
    return (
      <div className="dish cms">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <div className="cms__bar">
              <div className="cms__bar-left">
                <h1 className="h2">Dish Library</h1>
                <p className="p p--dark-taupe">
                  {pagination.total_items || 0} Total
                </p>
              </div>
              <div className="cms__bar-right">
                <Link to="/admin/dish" className="btn btn--solid-blue">
                  Add a New Dish
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <div className="cms__bar">
              <div className="cms__bar-left">
                <SearchInput
                  placeholder="Search Dishes"
                  value={searchTerm}
                  onChange={handleChange}
                />
              </div>
              <div className="cms__bar-right">
                <FilterBar
                  activeFilters={activeFilters}
                  availableFilters={availableFilters}
                  toggleFilter={toggleFilter}
                  swapFilter={swapFilter}
                  includeFormsy="true"
                />
              </div>
            </div>

            <ActiveFilters
              activeFilters={activeFilters}
              toggleFilter={toggleFilter}
            />

            <div className="cms__list-wrap">
              <SortableList
                columns={columns}
                rows={dishes}
                sort={sortBy}
                ListItem={ListItem}
                handleSort={handleSort}
                isLoading={isLoading}
              />
            </div>
            <div className="cms__pagination">
              <Pagination
                pageCount={pagination.total_pages || 1}
                forcePage={pagination.current_page - 1 || 0}
                onPageChange={handlePaginate}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleSort = prop => {
    const column = this.columns.find(c => c.key === prop);
    const isSortable = prop && (!column.sortable || column.sortable !== false);
    // don't do anything is the property is marked as `sortable: false`
    if (!isSortable) return;

    let { sortBy } = this.state;

    const index = sortBy.findIndex(option => prop in option);
    if (index >= 0 && sortBy[index][prop] === 'asc') {
      sortBy[index][prop] = 'desc';
    } else if (index >= 0 && sortBy[index][prop] === 'desc') {
      sortBy = [
        ...sortBy.slice(0, index),
        ...sortBy.slice(index + 1, sortBy.length)
      ];
    } else {
      sortBy.push({ [prop]: 'asc' });
    }
    this.setState({ sortBy }, this.debouncedLoadDishes);
  };

  handlePaginate = ({ selected: page }) => {
    this.loadDishes(page + 1);
  };

  handleChange = e => {
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const name = e.target.name;

    this.setState({ [name]: value }, this.debouncedLoadDishes);
  };

  toggleFilter = newFilter => {
    const activeFilters = [...this.state.activeFilters];
    const i = activeFilters.findIndex(filter => filter.key === newFilter.key);
    if (i >= 0) activeFilters.splice(i, 1);
    else activeFilters.push(newFilter);

    this.setState({ activeFilters }, this.debouncedLoadDishes);
  };

  swapFilter = newFilter => {
    const activeFilters = [...this.state.activeFilters];

    // same key? delete
    const x = activeFilters.findIndex(filter => filter.key === newFilter.key);
    if (x >= 0) activeFilters.splice(x, 1);
    else {
      // dif key? delete + add
      const i = activeFilters.findIndex(
        filter => filter.type === newFilter.type
      );
      if (i >= 0) activeFilters.splice(i, 1);

      // add
      activeFilters.push(newFilter);
    }

    this.setState({ activeFilters }, this.debouncedLoadDishes);
  };

  loadDishes = (page = 1) => {
    const { searchTerm: name, sortBy: sort } = this.state;
    const search = parseFilters(this.state.activeFilters);
    search.name = name;
    // console.log(JSON.stringify({page, sort, search}));

    // clear existing
    this.setState({ dishes: [], isLoading: true });

    // make request
    menuAPI
      .searchDishes({ page, sort, search, per_page: 50 })
      .then(({ dishes, pagination }) =>
        this.setState({ dishes, pagination, isLoading: false })
      )
      .catch(error => console.log(error));
  };

  // react's correct implementation of debounce
  debouncedLoadDishes = debounce(() => this.loadDishes(), 250);

  componentDidMount() {
    this.loadDishes();

    menuAPI
      .getDiets()
      .then(({ dietary_preference_tags: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.dietary_preference_tags.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getSeasonality()
      .then(({ seasonality_tags: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.seasonality_tags.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getCuisines()
      .then(({ cuisines: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.cuisine.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getCategories()
      .then(({ dish_categories }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.category.options = dish_categories
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));

    menuAPI
      .getAllergens()
      .then(({ allergen_tags: options }) => {
        const availableFilters = { ...this.state.availableFilters };
        availableFilters.allergens.options = options;
        this.setState({ availableFilters });
      })
      .catch(error => console.log(error));
  }
}

export default withTracker(AdminDishes);



// WEBPACK FOOTER //
// ./src/components/admin/AdminDishes.js